var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
            'button-favorite btn btn--transparent js--blur',
            {'button-favorite__preloader': _vm.loading} ],attrs:{"type":"button","title":_vm.pageIsFavorite ? 'Убрать из избранного' : 'Добавить в избранное',"disabled":_vm.loading},on:{"click":_vm.onClick}},[_c('svg',{class:[
            'button-favorite__icon',
            {'button-favorite__icon--yellow': _vm.pageIsFavorite},
            {'button-favorite__icon--hide': _vm.loading} ]},[_c('use',{attrs:{"xlink:href":"#icon-star"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }